'use client';

import { c as _c } from "react/compiler-runtime";
import { ErrorBoundary } from '@datadog/browser-rum-react';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { SomethingWentWrong } from '@shared/components/SomethingWentWrong';
import { ToastProvider } from '@shared/context/Toast';
import { ROUTES } from '@shared/routes';
import { lightTheme } from '@shared/theme';
import { type Session } from 'next-auth';
import { SessionProvider, signOut } from 'next-auth/react';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { type ReactNode, useEffect, useMemo } from 'react';
interface BaseLayoutProps {
  children: ReactNode;
  session: Session | null;
  nonce: string;
}
export const BaseLayout: React.FC<BaseLayoutProps> = t0 => {
  const $ = _c(15);
  const {
    children,
    session,
    nonce
  } = t0;
  let t1;
  if ($[0] !== session?.error) {
    t1 = () => {
      if (session?.error === "RefreshAccessTokenError") {
        signOut();
      }
    };
    $[0] = session?.error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = session?.error;
  let t3;
  if ($[2] !== t2) {
    t3 = [t2];
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t1, t3);
  let t4;
  if ($[4] !== nonce) {
    t4 = createCache({
      key: "mui",
      nonce,
      prepend: true
    });
    $[4] = nonce;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const emotionCache = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CssBaseline />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== children) {
    t6 = <ThemeProvider theme={lightTheme}><ToastProvider>{t5}{children}</ToastProvider></ThemeProvider>;
    $[7] = children;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== session || $[10] !== t6) {
    t7 = <ErrorBoundary fallback={_temp}><NuqsAdapter><SessionProvider session={session}>{t6}</SessionProvider></NuqsAdapter></ErrorBoundary>;
    $[9] = session;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== emotionCache || $[13] !== t7) {
    t8 = <CacheProvider value={emotionCache}>{t7}</CacheProvider>;
    $[12] = emotionCache;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
function _temp(t0) {
  const {
    resetError
  } = t0;
  return <SomethingWentWrong goBackHref={ROUTES.jobs.base} reset={resetError} />;
}